import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TipoMaterialN1 } from "../../types/materiaisN1.types";

interface ModalExportarProps {
  open: boolean;
  onClose: () => void;
  tipoMaterial: TipoMaterialN1;
  totalFiltrados: number;
  onExportar: () => Promise<void>;
}

export const ModalExportar: React.FC<ModalExportarProps> = ({
  open,
  onClose,
  tipoMaterial,
  totalFiltrados,
  onExportar,
}) => {
  const [exportando, setExportando] = useState(false);

  const handleExportar = async () => {
    setExportando(true);
    try {
      await onExportar();
      onClose();
    } catch (error) {
      console.error("Erro ao exportar:", error);
    } finally {
      setExportando(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          maxWidth: "400px",
        },
      }}
    >
      <DialogTitle sx={{ color: "#3C90AD", fontWeight: 600, pb: 1 }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h6">Exportar produtos</Typography>
          </Grid>
          <Grid item>
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{ color: "#3C90AD" }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          Deseja exportar <strong>{totalFiltrados} produtos</strong> (todos os filtrados)?
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" sx={{ borderColor: "#3C90AD", color: "#3C90AD" }}>
          CANCELAR
        </Button>
        <Button
          onClick={handleExportar}
          variant="contained"
          sx={{
            backgroundColor: "#3C90AD",
            "&:hover": { backgroundColor: "#2d6f87" },
            "&:disabled": { backgroundColor: "#ccc" },
          }}
        >
          {exportando ? "EXPORTANDO..." : "EXPORTAR"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
